import React from 'react';
import { styled } from 'baseui';
import { AnnotationLabeledList } from '../annotations-common/annotation-labeled-list';
import { EmptyState } from '../common/empty-state';
import { useMLAnnotations } from '../hooks/use-ml-annotations';
import { useImportHandlers } from './hooks/use-import-handlers';
import { ActionButtons } from './action-buttons';
import { AnnotationDetailHeader } from './annotation-detail-header';
import { AnnotationDetailItem } from './annotation-detail-item';
const PanelContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: 1,
  overflow: 'hidden'
});
const ListContainer = styled('div', ({
  $theme
}) => ({
  overflow: 'hidden',
  paddingRight: $theme.sizing.scale0,
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column'
}));
export function MLAnnotationsPanel() {
  const {
    mlAnnotations,
    pendingMLAnnotations,
    importedMLAnnotationIds
  } = useMLAnnotations();
  const hasAnnotations = pendingMLAnnotations.length > 0;
  const {
    checkedAnnotationIds,
    handleCheckAnnotation,
    handleSelectAll,
    handleImport
  } = useImportHandlers({
    annotations: pendingMLAnnotations
  });
  if (!hasAnnotations) {
    return <EmptyState title="No ML annotations" size={50} />;
  }
  return <PanelContainer>
      <ListContainer>
        <AnnotationLabeledList annotations={mlAnnotations} importedAnnotationIds={importedMLAnnotationIds} header={(headerInfo, label, icon) => <AnnotationDetailHeader headerInfo={headerInfo} label={label} icon={icon} />} item={(annotation, isFocused, icon) => <AnnotationDetailItem annotation={annotation} icon={icon} isFocused={isFocused} checkedAnnotationIds={checkedAnnotationIds} handleCheckAnnotation={handleCheckAnnotation} />} />
      </ListContainer>

      <ActionButtons checkedAnnotationIds={checkedAnnotationIds} onSelectAll={handleSelectAll} onImport={handleImport} />
    </PanelContainer>;
}